/*
 * @Descripttion: 文件路由集合
 * @version: 
 * @Author: luoxi
 * @Date: 2020年3月16日11:51:55
 * @LastEditors: lixianbing
 * @LastEditTime: 2020年4月16日11:51:59
 */

import Layout from '@/layout'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/plugins/utils/import.' + process.env.NODE_ENV)

const meta = { auth: true }

const profix = process.env.VUE_APP_ROUTER_PROFIX

export default {
  path: '/' + profix,
  name: '/' + profix,
  meta: { ...meta, title: '全部文件' },
  redirect: { path: '/' + profix + '/home' },
  component: Layout,
  children: (pre => [
    {
      path: `${pre}/home`, name: `home`, component: _import('main/home'), meta: { ...meta, title: '团队报名', icon: 'iconfont iconbaoming' }
    },
    {
      path: `${pre}/fileshare`, name: `fileshare`, component: _import('main/home/fileshare'), meta: { ...meta, title: '附件分享地址', icon: 'iconfont icondianzifujian' },
    },
    {
      path: `${pre}/examine`, name: `examine`, component: _import('main/home/examine'), meta: { ...meta, title: '报名审核', icon: 'iconfont iconshenhe' },
    },
    {
      path: `${pre}/webpay`, name: `webpay`, component: _import('main/home/webpay'), meta: { ...meta, title: '网上缴费', icon: 'iconfont iconshuaka' },
    },
    {
      path: `${pre}/payselect`, name: `payselect`, component: _import('main/home/payselect'), meta: { ...meta, title: '缴费查询', icon: 'iconfont iconshuaka' },
    },
    // {
    //   path: `${pre}/examine`, name: `examine`, component: _import('main/home/examine'), meta: { ...meta, title: '报名审核', icon: 'iconfont icondingdan-' },
    // },
    // {
    //   path: `${pre}/webpay`, name: `webpay`, component: _import('main/home/webpay'), meta: { ...meta, title: '网上缴费', icon: 'iconfont icondingdan-' },
    // },
    // {
    //   path: `${pre}/payselect`, name: `payselect`, component: _import('main/home/payselect'), meta: { ...meta, title: '缴费查询', icon: 'iconfont icondingdan-' },
    // }

    // {
    //   path: `${pre}/home`, name: `home`, component: _import('main/home'), meta: { ...meta, title: '我的信息', icon: 'iconfont icondingdan-' },
    // },
    // { path: `${pre}/regisactive`, name: `regisactive`, component: _import('main/home/regisactive'), meta: { ...meta, title: '报名活动', icon: 'iconfont iconhuodong' } },
    // { path: `${pre}/resetpassword`, name: `resetpassword`, component: _import('main/home/resetpassword'), meta: { ...meta, title: '重置密码', icon: 'iconfont iconzhongzhimima' } }
  ])('/' + profix)
}
